import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../components/reexamination-orders/Main";
import { PERMISSIONS } from "../configs/constants";
import { useHasAuthorityHook } from "../app/useHasAuthorityHook";

/**
 * 再審査指示・判定
 */
const ReexaminationOrders = () => {
  const isExamine = useHasAuthorityHook(PERMISSIONS.EXAMINE);
  const isMasterApproval = useHasAuthorityHook(PERMISSIONS.MASTER_APPROVAL);
  const isDocomoAdminUser = !!isExamine && !!isMasterApproval;
  const navigate = useNavigate();

  useEffect(() => {
    if (!isDocomoAdminUser) {
      navigate("/");
    }
  }, [isDocomoAdminUser, navigate]);

  return <Main />;
};

export default ReexaminationOrders;
